import { getDefaultSortOption } from 'common/features/Filters/predefined/SortGroup/store/recent.defaults';
import { SortOptionsEnum } from 'common/features/VirtualList/VirtualList.config';
import { FavoritesModalFiltersState } from './filter.types';

export const getDefaultFilters = (): FavoritesModalFiltersState => ({
  ...getDefaultSortOption(SortOptionsEnum.MOST_RECENT),
});

export const filterInitialState: FavoritesModalFiltersState = getDefaultFilters();
